/* eslint-disable no-param-reassign */
// we enable param reassign in this file because scrolling DOM elements involves mutating the element's scrollTop property

export default class ScrollUtil {
  static scrollElementIntoView(containerEl, childEl) {
    if (!containerEl || !childEl) {
      return;
    }

    const containerHeight = containerEl.offsetHeight;
    const childHeight = childEl.offsetHeight;

    const visibleAreaTop = containerEl.scrollTop;
    const visibleAreaBottom = visibleAreaTop + containerHeight;

    const searchResultTop = childEl.offsetTop;
    const searchResultBottom = searchResultTop + childHeight;

    if (searchResultTop < visibleAreaTop) {
      containerEl.scrollTop = searchResultTop;
    } else if (searchResultBottom > visibleAreaBottom) {
      containerEl.scrollTop = searchResultBottom - containerHeight; // position scroll so that the bottom of the search result is at the bottom of the dropdown
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/ScrollUtil.js